import { Decodable } from './_decodable'

class Supplier extends Decodable {
    id?: number
    cnpj?: string
    razaoSocial?: string
    phone?: string
    email?: string
    responsible?: string
    address?: string
    addressNumber?: string
    addressNeighborhood?: string
    addressComplement?: string
    addressCity?: string
    addressState?: string
    cep?: string
    status?: number
    createdAt?: Date
    updatedAt?: Date

    protected _map = {
        createdAt: (e: any) => this.parseDate(e),
        updatedAt: (e: any) => this.parseDate(e),
    }
}

export {
    Supplier
}
